import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useMySets() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["me", "sets"],
    queryFn: () => api.get("/me/sets").then((r) => r.data.items),
    enabled: Boolean(user),
  });
}

export function useMyCardBacks() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["me", "card-backs"],
    queryFn: () => api.get("/me/card-backs").then((r) => r.data.items),
    enabled: Boolean(user),
  });
}

export const emptyFace = () => ({
  name: "", mana_cost: "", type_line: "", oracle_text: "", flavor_text: "",
  power: "", toughness: "", loyalty: "", defense: "", artist: "", image_file_id: null, image_url: null,
});

const OPTIONAL = ["power", "toughness", "loyalty", "defense", "artist"];

export function facePayload(face) {
  const out = {};
  ["name", "mana_cost", "type_line", "oracle_text", "flavor_text", ...OPTIONAL, "image_file_id"].forEach((k) => {
    const v = typeof face[k] === "string" ? face[k].trim() : face[k];
    out[k] = OPTIONAL.includes(k) || k === "image_file_id" ? v || null : v || "";
  });
  return out;
}
